import { KJUR } from 'jsrsasign';
import {
  AUTH_LOGOUT,
  AUTH_REFRESH,
  AUTH_REQUEST,
  AUTH_GOOGLE,
  AUTH_FACEBOOK,
  AUTH_SUCCESS,
  SET_REQUESTED_PATH,
  SET_AUTH_ERRORS,
  GET_USER_CONTACT_INFO,
  SET_USER_CONTACT_INFO,
} from '@/store/mutationTypes.js';
import { UNAUTHORIZED_ROUTES_NAMES } from '@/settings.js';
import { login, externalLogin, refreshToken, googleLogin } from '@/api/user.js';
import { getCurrentUserContactInfo, getOnboardingStatus } from '@/api/profile.js';
import router from '@/router/index.js';

const INITIAL_STATE = {
  accessToken: null,
  accessTokenExpires: 0,
  refreshToken: null,
  refreshTokenExpires: 0,
  userId: null,
  authErrors: null,
  userContactInfo: null,
  role: null,
};

const state = Object.assign({}, INITIAL_STATE);

const getters = {
  isAccessTokenValid: ({ accessTokenExpires }) => (now) =>
    now < accessTokenExpires,
  isRefreshTokenValid: ({ refreshTokenExpires }) => (now) =>
    now < refreshTokenExpires,
};

const mutations = {
  [AUTH_SUCCESS]: (state, { accessToken, refreshToken }) => {
    // дешифруем токен доступа, достаем идентификатор пользователя, дату начала, истечения
    const {
      payloadObj: { sub: userId, exp: accessTokenExpires, role },
    } = KJUR.jws.JWS.parse(accessToken);

    // дешифруем токен обновления, достаем дату начала и истечения
    const {
      payloadObj: { exp: refreshTokenExpires },
    } = KJUR.jws.JWS.parse(refreshToken);

    // обновляем состояние
    state = Object.assign(state, {
      userId,
      accessToken,
      accessTokenExpires,
      refreshToken,
      refreshTokenExpires,
      role
    });
  },

  [AUTH_LOGOUT]: (state) => {
    state = Object.assign(state, INITIAL_STATE);
    // перенаправляем на страницу логина
    if (router.currentRoute.name !== UNAUTHORIZED_ROUTES_NAMES[0]) {
      router.push({ name: UNAUTHORIZED_ROUTES_NAMES[0] });
    }
  },

  [SET_REQUESTED_PATH]: (state, { path }) => {
    state.requestedPath = path;
  },

  [SET_AUTH_ERRORS]: (state, { errors }) => {
    state = Object.assign(state, { authErrors: errors });
  },

  [SET_USER_CONTACT_INFO]: (state, { data }) => {
    state.userContactInfo = data;
  },
};

// действие принимает первым аргументом context, вторым payload
const actions = {
  [AUTH_REQUEST]: async function({ state, dispatch, commit }, credentials) {
    const { data, success, errors } = await login(credentials);

    return processLoginResponse(success, data, errors, commit, state, dispatch);
  },

  [AUTH_REFRESH]: async function({ state, commit }) {
    const { data, success } = await refreshToken({
      token: state.refreshToken,
    });
    if (success) {
      const { accessToken, refreshToken } = data;
      commit(AUTH_SUCCESS, { accessToken, refreshToken });
    } else {
      commit(AUTH_LOGOUT);
    }
    return data.accessToken;
  },

  [AUTH_GOOGLE]: async function({ state, dispatch, commit }, authResponse) {

    //console.log('authResponse', authResponse);

    const { data, success, errors } = await googleLogin({
      code: authResponse.code,
    });

    return processLoginResponse(success, data, errors, commit, state, dispatch);
  },

  [AUTH_FACEBOOK]: async function({ state, dispatch, commit }, authResponse) {
    const { data, success, errors } = await externalLogin({
      authResponse,
      providerType: 'facebook',
    });

    return processLoginResponse(success, data, errors, commit, state, dispatch);
  },

  [GET_USER_CONTACT_INFO]: async function({ commit }) {
    const { data, success } = await getCurrentUserContactInfo();

    if (success) {
      commit(SET_USER_CONTACT_INFO, { data });
    }
  },
};

export default {
  //namespaced: true,
  state,
  getters,
  mutations,
  actions,
};


async function processLoginResponse(success, data, errors, commit, state, dispatch) {
  if (success) {
    const { accessToken, refreshToken } = data;

    commit(AUTH_SUCCESS, { accessToken, refreshToken });

    commit(SET_REQUESTED_PATH, { path: null });

    dispatch(GET_USER_CONTACT_INFO);
    
    let isComplete = false;

    try {
      const status = await getOnboardingStatus(); // e.g. { onboardingStatus: 'Completed' } or null

      console.log('Onboarding status:', status);

      // Treat null as complete (per requirement)
      if (status.data == null) {
        isComplete = false;
      } else {
        isComplete = (status.data.toLowerCase() == "completed" ); 
      }
    } catch {
      // Network/parse error → be lenient and send user home
      isComplete = true;
    }

    ///console.log('Onboarding complete or null:', isComplete, ' res: ' + JSON.stringify(data));

    if (isComplete) {
      await router.replace({ name: 'Home' });
    } else {
      console.log('Redirecting to Onboarding');
      await router.replace({ name: 'Onboarding' }); // change to your onboarding route name
    }

  } else {
    commit(AUTH_LOGOUT);
    commit(SET_AUTH_ERRORS, { errors });
  }

  return { success };
}


